import {Component} from 'react';
import Snackbar from "@mui/material/Snackbar";

import informationTextDataset from './Datasets/information_text_dataset';

class InformationModal extends Component {
        constructor(props) {
            super(props);
            this.state={
               
            }
            this.initializeText();
    }       

    // this was converted from a modal to a "Snackbar" which is automatically closed after "this.nbrSeconds"
    initializeText(){
        if (this.props.infoCode === "NoCode"){
            this.displayText = this.props.informationText;
            this.title = this.props.informationTitle;
        }else{
            const textObj = informationTextDataset.find(elem => elem.informationCode === this.props.infoCode);
            if (textObj){
                this.displayText = textObj.text;
                this.title = textObj.title;
            }else{
                this.title = "Good Job!"
                this.displayText = "You have successfully completed this task."
            }
        }
        if (this.props.time){
            this.nbrSeconds = this.props.time;
        }else{
            this.nbrSeconds = 6000;
        }
    }


    handleClose = (event, reason) => {
        if (reason === 'clickaway'){
            return;
        }else{
            this.props.onClose();
        };
    }
        
         
    render() {
  
   
    return <>
        <div style={{ padding: "2rem" }}>
    
        <Snackbar
            open={this.props.show}
            autoHideDuration={this.nbrSeconds}
            onClose={this.handleClose}
            onClick={() => this.props.onClose()} 
            anchorOrigin={{ vertical: "top", horizontal: "center" }}
            message={
            <div className="custom-snackbar">
                {/* Header */}
                <div className="snackbar-header">
                <strong>{this.title}</strong>
                </div>

                {/* Main Content */}
                <div className="snackbar-body">
                <p>{this.displayText}</p>
                </div>

                {/* Bottom Section */}
                <div className="snackbar-footer">
                <img
                    src="https://cdn-icons-png.flaticon.com/512/148/148767.png"
                    alt="checkmark"
                />
                </div>
                {this.props.gotItBtn  ?
                    <div className="snackbar-footer">
                        <button
                            onClick={() => this.props.onClose()}
                            style={{
                                marginTop: "0.5rem",
                                padding: "0.4rem 1.2rem",
                                cursor: "pointer",
                                backgroundColor: "#1976d2",
                                color: "white",
                                border: "none",
                                borderRadius: "4px",
                                fontSize: "0.9rem"
                            }}
                        >
                            Got it!
                        </button>
                    </div>
                :
                    null
                }
            </div>
            }
        />
        </div>                
    </>
}         

}

export default InformationModal;